import React from 'react';
import { X, Download, Smartphone } from 'lucide-react';
import { usePWA } from '../hooks/usePWA';
import { useTheme } from '../contexts/ThemeContext';

const PWAInstallBanner: React.FC = () => {
  const { colors } = useTheme();
  const { showInstallBanner, isInstalled, installApp, dismissInstallBanner } = usePWA();

  if (!showInstallBanner || isInstalled) {
    return null;
  }

  const handleInstall = async () => {
    const success = await installApp();
    if (success) {
      console.log('App installed successfully');
    }
  };

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4 shadow-lg border-t animate-slide-up"
      style={{ 
        backgroundColor: colors.surface,
        borderColor: colors.border
      }}
    >
      <div className="flex items-center justify-between max-w-md mx-auto">
        <div className="flex items-center gap-3 flex-1">
          <div 
            className="p-2 rounded-lg"
            style={{ backgroundColor: `${colors.primary}20` }}
          >
            <Smartphone size={24} style={{ color: colors.primary }} />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-sm" style={{ color: colors.textPrimary }}>
              Install FMK App
            </h3>
            <p className="text-xs" style={{ color: colors.textSecondary }}>
              Get the full experience with offline access
            </p>
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <button
            onClick={handleInstall}
            className="flex items-center gap-2 px-3 py-2 rounded-lg font-medium text-sm transition-opacity hover:opacity-80"
            style={{ 
              backgroundColor: colors.primary,
              color: 'white'
            }}
          >
            <Download size={16} />
            Install
          </button>
          <button
            onClick={dismissInstallBanner}
            className="p-2 rounded-lg transition-opacity hover:opacity-60"
            style={{ color: colors.textSecondary }}
          >
            <X size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAInstallBanner;